export const LLM_TAB_PATHNAME = {
  prompts: 'prompts',
  embeddings: 'embeddings',
  playground: 'playground'
};
